import React from "react"
import styled from "styled-components"
import { H4 } from "./UIStyle/UIstyle"
import { theme } from "./mixin"

export default function CountBar({
  total,
  days,
  hours,
  minutes,
  seconds,
  dayS,
  dayE
}) {
  return (
    <>
      {total ? (
        <Wrapper>
          <MediumWrapper>
            <CountBarWrapper>
              <CounterWrapper
                Percent={100 - (total / (dayE - dayS)) * 100}
              ></CounterWrapper>
            </CountBarWrapper>
          </MediumWrapper>
          <BottomWrapper>
            <H4>
              剩 {days} 天 {hours} 時 {minutes} 分結束
            </H4>
          </BottomWrapper>
        </Wrapper>
      ) : null}
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: 3px;
  flex-direction: column;
  width: clamp(00px, 100%, 350px);
  justify-content: center;
  align-content: center;

  @media (${theme.md}) {
    max-width: 300px;
  }
  @media (${theme.sm}) {
  }
`

const MediumWrapper = styled.div``
const BottomWrapper = styled.div`
  p {
    font-size: 20px;
    @media (${theme.md}) {
      text-align: center;
    }
  }
`
const CountBarWrapper = styled.div`
  width: 100%;
  border: 1px solid ${theme.CTAcolor};
  border-radius: 12px;
  display: flex;
  justify-content: start;
`
const CounterWrapper = styled.div`
  width: ${({ Percent }) => Percent}%;
  background: ${theme.CTAcolorLinear};
  border-radius: 12px;
  height: 6px;
`

const A = styled.div``
